<template>
  <div class="flex justify-content-center">
    <div v-for="documentRequests in documentRequests" :key="documentRequests['reference']">
      <p>Message from Admissions Team:</p>
      <p class="mb-4"><i>{{ documentRequests['message'] }}</i></p>
      <p><strong>Please upload the following:</strong></p>
      <ol>
        <li v-for="(name, reference) in documentRequests['document_types_remaining']" :key="reference" class="list-decimal ml-4">{{ name }}</li>
      </ol>
      <div class="w-full">
        <h2 class="mt-4">Upload a document</h2>
        <form @change="dirtyForm(documentRequests['application_id'], documentRequests['reference'])" @submit.prevent="uploadData">
          <div class="py-4">
            <div class="w-full text-left">
              <select-input id="documentTypeSelect"
                            v-model="form.document_type"
                            :error="form.errors?.document_type"
                            label="Document Type"
                            @update:modelValue="value = $event"
              >
                <option v-for="(name, reference ) in documentRequests['document_types_remaining']"
                        :key="reference"
                        :value="reference"
                >
                  {{ name }}
                </option>
              </select-input>
            </div>
            <div>
              <file-input v-model="form.file" :value="form.file" label="Select document to upload" type="file" @change="form.file = $event.target.files[0]"
                          @remove="form.file = value"
              />
            </div>


            <div>
              <button :class="{ 'opacity-25 cursor-not-allowed': !form.file || !form.document_type }"
                      :disabled="!form.file || !form.document_type"
                      class="text-sm mt-2 flex btn-green ml-auto md:inline-block text-center relative"
                      tabindex="-1"
                      type="submit"
              >
                Upload document
                <div v-if="loading" class="lds-ring-container absolute top-2 left-4 "><div class="lds-ring"><div /><div /><div /><div /></div></div>
              </button>
            </div>
            <div v-if="successMessage" class="success-message mt-4 w-full lg:w-1/2">{{ successMessage }}</div>
            <div v-if="serverError" class="server-error w-full lg:w-1/2">{{ serverError }}</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'
import FileInput from "@/shared/FileInput";

export default {
  components: {
    ApplicationComponentSaveButton,
    TextInput,
    SelectInput,
    FileInput
  },
  props: {
    documentRequests : Array,
  },
  data() {
    return {
      selectedProgrammeMode: '',
      selectedProgramme: null,
      selectedCourse: null,
      filteredCourses: [],
      filteredProgrammes: [],
      proposedStartDate: '',
      proposedResearchTopic: '',
      proposedSupervisor: '',
      mrcStaff: '',
      proposedStartDateShow: false,
      form: {},
      formDirty: false,
      loading: false,
      successMessage: '',
      serverErrors: '',
      applicationRef: this.$route.params.id,
    }
  },
  mounted() {
      this.changeType({})
  },
  methods: {
    changeProgramme(event) {
      this.$emit('programmeChange', event.target.value)
    },
    uploadData() {
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.form.file)
      formData.append('reference', this.form.reference)
      formData.append('document_request_reference', this.form.documentRequestReference)
      formData.append('document_type', this.form.document_type)
      this.$store.dispatch('uploadDocument', {
        applicationRef: this.form.reference,
        file: formData,
      })
          .then((response) => {
            this.loading = false
            this.successMessage = response.data
            this.serverError = ''
            location.reload()
          })
          .catch(error => {
            this.loading = false
            this.successMessage = ''
            this.serverError = error.response.data.errors.file[0]
          })
    },
    dirtyForm(applicationReference, reference) {
      this.form.reference = applicationReference
      this.form.documentRequestReference = reference
      this.formDirty = true
      this.successMessage = ''
    },
    cancelForm () {
      this.$emit('cancelForm')
    },
  },
}
</script>
